import { timelineItems, timelineMarks } from "@/mocks/home";

export default function Timeline() {
  return (
    <section id="timeline" className="border-t border-background-200 bg-background-100 py-10 md:py-14">
      <div className="mx-auto grid w-full max-w-6xl gap-8 px-4 md:grid-cols-12 md:px-6">
        {/* 左：说明 + 阶段徽标 */}
        <div className="md:col-span-4">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-900">
              <i className="ri-time-line text-lg" />
            </span>
            <h3 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">时间线整理</h3>
          </div>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            本期重点：主播合约风波。从旧帖被翻到第二轮说法，把每一个节点按时间排好，配原始出处，方便你按图索骥地补课。
          </p>

          <div className="mt-5 flex flex-wrap gap-2">
            {timelineMarks.map((m, i) => (
              <span
                key={m}
                className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1.5 text-sm ${
                  i === 0
                    ? "bg-primary-500 text-background-50"
                    : i === timelineMarks.length - 1
                    ? "bg-accent-500 text-background-50"
                    : "bg-secondary-100 text-secondary-900"
                }`}
              >
                <span>{i + 1}</span> {m}
              </span>
            ))}
          </div>

          <div className="mt-6 flex items-center gap-3 rounded-lg bg-background-50 p-4">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700">
              <i className="ri-database-2-line text-lg" />
            </span>
            <div>
              <p className="text-sm font-semibold text-foreground-950">持续更新中</p>
              <p className="text-xs text-foreground-500">本时间线以最新声明为准，节点按出现顺序追加，不再回填。</p>
            </div>
          </div>
        </div>

        {/* 右：竖向时间轴 */}
        <div className="md:col-span-8">
          <div className="relative flex flex-col gap-4 border-l-2 border-foreground-200 pl-6 md:pl-8">
            {timelineItems.map((item) => (
              <article key={item.time} className="group relative">
                {/* 时间轴圆点 */}
                <span className="absolute -left-[35px] top-5 flex h-4 w-4 items-center justify-center md:-left-[47px]">
                  <span className="h-4 w-4 rounded-full border-2 border-background-100 bg-primary-500 transition-transform group-hover:scale-125" />
                </span>
                <div className="flex flex-col gap-1 rounded-lg bg-background-50 p-5 transition-colors group-hover:bg-background-50/70 sm:flex-row sm:items-start sm:gap-5">
                  <span className="shrink-0 font-heading text-sm font-semibold text-primary-600">{item.time}</span>
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <span className="whitespace-nowrap rounded-full bg-accent-100 px-2 py-0.5 text-xs text-accent-900">
                        {item.type}
                      </span>
                      <h4 className="text-base font-semibold text-foreground-950">{item.title}</h4>
                    </div>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  </div>
                </div>
              </article>
            ))}
          </div>

          <div className="mt-6 flex items-center justify-center gap-2 text-sm text-foreground-500">
            <i className="ri-arrow-down-line" />
            时间线仍在更新，有新节点会在讨论区第一时间同步
          </div>
        </div>
      </div>
    </section>
  );
}